import React from 'react'

import Loading from './loading'

class NotFound extends React.Component {
    public componentDidMount() {
        window.location.reload()
    }

    public render() {
        return <Loading />
    }
}

export default NotFound
